import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./KtnlEnquiryforms.css";
import CONFIG from "../src/config";
import Swal from "sweetalert2";
import "font-awesome/css/font-awesome.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const debounce = (func, delay) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

const KtnlEnquiryforms = () => {
  const [contactData, setContactData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchItem, setSearchItem] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  const handleClick = (id, customername) => {
    Swal.fire({
      title: "Enquiry Details",
      text: "",
      html: `
          <p class="confimrmodel">Are you sure you want to delete?</p>
          <p>${customername}</p>
          <p class="warnmodel">
            <i class="fa fa-exclamation-triangle" style="font-size: 18px; color: #d33; margin-right: 8px;"></i>
            <span>You cannot recover the data after deleting.</span>
          </p>
        `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, customername);
      }
    });
  };

  const fetchData = async (page = 1, searchQuery = "") => {
    try {
      const response = await axios.get(
        `${CONFIG.BASE_URL}/BrAcademy/Enquiryform?page=${page}&limit=${itemsPerPage}&search=${searchQuery}`
      );
      setContactData(response.data.enquirys);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, searchItem);
  }, [currentPage, searchItem]);

  const handleDelete = (id, customername) => {
    if (!id) {
      console.error("Invalid ID:", id);
      return;
    }

    axios
      .delete(`${CONFIG.BASE_URL}/BrAcademy/Enquiryform/${id}`)
      .then((response) => {
        setContactData(contactData.filter((item) => item._id !== id));
        toast.success("Enquiry deleted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((error) => {
        toast.error("Error!", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const debouncedSearch = useCallback(
    debounce((query) => {
      fetchData(1, query);
      setCurrentPage(1);
    }, 500),
    []
  );

  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
    debouncedSearch(e.target.value);
  };

  return (
    <div
      className="table-container lp_enquiry wow fadeInUp"
      data-wow-delay="0.2s"
    >
      <ToastContainer />

      <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div className="breadcrumb-title pe-3">
          <h5>KTNL ENQUIREY FORMS</h5>
        </div>
        <div className="ms-auto  col-md-3">
          <div className="btn-group w-100 pe-3">
            <div className="search-container w-100">
              <input
                className="form-control search-input"
                type="text"
                placeholder="Search..."
                value={searchItem}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
      </div>
      <table className="data-table mt-0">
        <thead>
          <tr>
            <th width="5%">S.No</th>
            <th width="40%">Customer Name</th>
            <th width="20%">Email</th>
            <th width="20%">Contact</th>
            <th width="10%">Amount</th>
            <th width="5%">Actions</th>
          </tr>
        </thead>
        <tbody>
          {contactData.map((item, index) => (
            <tr key={item._id}>
              <td width="5%">{(currentPage - 1) * itemsPerPage + index + 1}</td>
              <td width="40%">{item.customername}</td>
              <td width="20%">{item.email}</td>
              <td width="20%">{item.contact}</td>
              <td width="10%">{item.amount}</td>
              <td width="5%">
                <button
                  className="custom-btn-delete ms-0"
                  onClick={() => handleClick(item._id, item.customername)}
                >
                  <i className="fa fa-trash" style={{ color: "white" }}></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pagination">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <i className="fa fa-chevron-left" aria-hidden="true"></i>
        </button>

        {Array.from({ length: Math.min(7, totalPages) }, (_, index) => {
          const pageNumber =
            currentPage <= 4
              ? index + 1
              : Math.min(currentPage + index - 3, totalPages);

          if (pageNumber < 1 || pageNumber > totalPages) return null;

          return (
            <button
              key={pageNumber}
              onClick={() => handlePageChange(pageNumber)}
              className={currentPage === pageNumber ? "active" : ""}
            >
              {pageNumber}
            </button>
          );
        })}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default KtnlEnquiryforms;
